import { get, post, put, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/product', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getProductContent = async (pageId) => {
    try {
        const result = await get(`product/${pageId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getProductList = async (query) => {
    try {
        const result = await get(`product?${query ? query : ''}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getProductAllList = async (query = '') => {
    try {
        const result = await get(`product/all` + query);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getRandomProduct = async (categoryId, productId, count) => {
    try {
        let params = '';
        if (categoryId) {
            params += `categoryId=${categoryId}`;
        }
        if (count) {
            params += `&count=${count}`;
        }
        if (productId) {
            params += `&productId=${productId}`;
        }
        const result = await get(`product/random?${params}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getProductDetail = async (productId, accountId) => {
    try {
        const result = await get(
            `product/detail/${productId}${accountId > 0 ? '?accountId=' + accountId : ''}`,
        );

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getProductBasketCount = async (productId, accountId) => {
    try {
        const result = await get(
            `product/basketCount/${productId}${accountId > 0 ? '?accountId=' + accountId : ''}`,
        );

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createProduct = async (data) => {
    try {
        const result = await post('product', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateProduct = async (id, data) => {
    try {
        const result = await put(`product/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setRate = async (id, data) => {
    try {
        const result = await put(`product/rate/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteProduct = async (id) => {
    try {
        const result = await destroy(`product/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateLangContent = async (id) => {
    try {
        const result = await put(`product/languagesContent/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};
